import DOMPurify from 'dompurify';

export const isQuillEmpty = (value?: string): boolean => {
  if (!value) return true;

  const emptyStates = ['<p><br></p>', '<p></p>'];

  if (emptyStates.includes(value)) return true;

  const textContent = value.replace(/<[^>]*>/g, '').trim();
  return textContent === '';
};

const isAppLink = (href: string): boolean => {
  const { origin } = window.location;

  return href === origin || href.startsWith(`${origin}/`) || !/^([a-z][a-z\d+.-]*:|\/\/)/i.test(href);
};

const openLinksInNewTab = (html: string): string => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('a').forEach((anchor) => {
    const rel = isAppLink(anchor.getAttribute('href') ?? '') ? 'opener' : 'noopener noreferrer';

    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', rel);
  });
  return doc.body.innerHTML;
};

export const sanitizeRichText = (html?: string): string => {
  if (!html) return '';
  const sanitized = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      'p',
      'br',
      'strong',
      'em',
      'u',
      's',
      'a',
      'ul',
      'ol',
      'li',
      'h1',
      'h2',
      'h3',
      'blockquote',
      'code',
      'pre',
      'img',
      'span',
      'div',
      'sub',
      'sup',
    ],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'style', 'class', 'align', 'color', 'background'],
  });
  return openLinksInNewTab(sanitized);
};
